/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S3_Li5Inputs */

const tr_kvkkbasvuru_s3_li5 = /** @type {(inputs: Kvkkbasvuru_S3_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talep konusu (açık ve anlaşılır biçimde)`)
};

const en_kvkkbasvuru_s3_li5 = /** @type {(inputs: Kvkkbasvuru_S3_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject of the request (clearly and comprehensibly)`)
};

const de_kvkkbasvuru_s3_li5 = /** @type {(inputs: Kvkkbasvuru_S3_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegenstand des Anliegens (klar und verständlich)`)
};

const ru_kvkkbasvuru_s3_li5 = /** @type {(inputs: Kvkkbasvuru_S3_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предмет требования (чётко и понятно)`)
};

/**
* | output |
* | --- |
* | "Subject of the request (clearly and comprehensibly)" |
*
* @param {Kvkkbasvuru_S3_Li5Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s3_li5 = /** @type {((inputs?: Kvkkbasvuru_S3_Li5Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S3_Li5Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s3_li5(inputs)
	if (locale === "de") return de_kvkkbasvuru_s3_li5(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s3_li5(inputs)
	return tr_kvkkbasvuru_s3_li5(inputs)
});